import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5afd7975"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]

import { useThemeStore } from '@/stores/theme';
import { useNavMenuStore } from '@/stores/navMenu';
import { useCursorHover } from '@/directives/useCursorHover';
import { AlignmentType } from '@/types/AlignmentType';
import { DarkTheme, HorizontalNavigationAlignment, LightTheme, VerticalNavigationAlignment } from '@/constants/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationLinksLink',
  props: {
    element: {},
    text: {},
    alignment: {}
  },
  setup(__props: any) {

const props = __props;

const themeStore = useThemeStore();

const navMenuStore = useNavMenuStore();

const vCursorHover = useCursorHover();




return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("a", {
    class: _normalizeClass({ 'vertical-alignment': props.alignment === _unref(VerticalNavigationAlignment),
                  'horizontal-alignment': props.alignment === _unref(HorizontalNavigationAlignment),
                  'link-dark-theme': _unref(themeStore).theme === _unref(DarkTheme),
                  'link-light-theme': _unref(themeStore).theme === _unref(LightTheme) }),
    href: `#${_ctx.element}`,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(navMenuStore).close()))
  }, [
    _createTextVNode(_toDisplayString(_ctx.text), 1)
  ], 10, _hoisted_1)), [
    [_unref(vCursorHover)]
  ])
}
}

})